/* ============================================================
   c_cart-validation.js
   ────────────────────────────────────────────────────────────
   - cart.attributes に ship_together / preorder_acknowledged を保存
   - 必要なチェックが未完了の場合、checkout ボタンを無効化
   - 受注品の数量入力に preorder_limit を強制（PDP・cart 両方）
   ============================================================ */
(function () {
  'use strict';

  // このファイルは snippets/cart-drawer.liquid と sections/c_cart-validation.liquid の
  // 両方から読み込まれるため、cart ページでは同じ IIFE が 2 回実行される。
  // ガードが無いと document への委譲リスナーが二重登録され、
  // showLimitToast の setTimeout が交差してトーストがちらつく。
  if (window.__cCartValInit) return;
  window.__cCartValInit = true;

  // カートページには隠れたカートドロワーも本文より前に描画されるため、
  // 先頭の [data-cart-val] はドロワー側になる。お客様が見て操作するのは
  // カートページ側なので、そちらがあれば優先する。
  // カートページのセクションはあるのにカードが無いのは「確認不要になった」とき
  // （受注品を外した等）。カートページではドロワーは描き直されず古いままなので、
  // ドロワー側には戻らず null を返す（＝ロックしない）。
  function getValidationRoot() {
    var cartRoot = document.querySelector('[data-cart-val][data-context="cart"]');
    if (cartRoot) return cartRoot;
    if (document.querySelector('.c-cart-val-wrap')) return null;
    return document.querySelector('[data-cart-val]');
  }

  /* ── preorder limit map (variantId → limit) ────────────── */
  function getPreorderLimitMap() {
    var root = getValidationRoot();
    var map = {};
    if (!root) return map;
    var raw = root.getAttribute('data-preorder-limits') || '';
    raw.split(';').forEach(function (pair) {
      var p = pair.trim();
      if (!p) return;
      var parts = p.split(':');
      if (parts.length !== 2) return;
      var id = parts[0].trim();
      var lim = parseInt(parts[1], 10);
      if (id && lim > 0) map[id] = lim;
    });
    return map;
  }

  /* ── cart 内 quantity input への max 強制 ────────────────── */
  function applyCartLimits() {
    var map = getPreorderLimitMap();
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(function (input) {
      var id = input.getAttribute('data-quantity-variant-id');
      var lim = map[id];
      if (!lim) return;
      input.setAttribute('max', lim);
      input.dataset.cartValLimit = String(lim);
      var v = parseInt(input.value, 10);
      if (!isNaN(v) && v > lim) {
        input.value = lim;
      }
    });
  }

  function clampOnInput(e) {
    var input = e.target;
    if (!input.matches('input[data-cart-val-limit]')) return;
    var lim = parseInt(input.dataset.cartValLimit, 10);
    var v = parseInt(input.value, 10);
    if (!isNaN(v) && v > lim) {
      input.value = lim;
      showLimitToast(lim);
    }
  }

  /* ── PDP add-to-cart form の数量強制 ───────────────────── */
  function enforcePdpQuantity(e) {
    var form = e.target.closest('form[data-preorder="true"]');
    if (!form) return;
    var lim = parseInt(form.getAttribute('data-preorder-limit'), 10);
    if (!lim || lim <= 0) return;
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) return;
    var v = parseInt(qty.value, 10);
    if (!isNaN(v) && v > lim) {
      e.preventDefault();
      qty.value = lim;
      showLimitToast(lim);
    }
  }

  /* ── 文言（snippets/c_cart-validation-strings.liquid が埋め込む） ── */
  // Liquid の t は訳文の ' などを &#39; に変換して出すので、文字に戻す。
  // textContent にそのまま入れると「couldn&#39;t」と画面に出てしまう。
  // textarea は中身をタグとして解釈しないので、文字参照を戻すためだけに使える。
  function decodeEntities(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  var stringsCache = null;
  function getStrings() {
    if (stringsCache) return stringsCache;
    var parsed = {};
    var el = document.querySelector('[data-c-cart-val-strings]');
    if (el) {
      try { parsed = JSON.parse(el.textContent) || {}; } catch (err) { parsed = {}; }
    }
    stringsCache = {
      limit_toast: decodeEntities(parsed.limit_toast) || 'You can order up to __LIMIT__ of this item',
      save_error: decodeEntities(parsed.save_error) || "We couldn't save your selection. Please try again."
    };
    return stringsCache;
  }

  /* ── 警告トースト（最小限） ─────────────────────────── */
  function showLimitToast(limit) {
    showToast(getStrings().limit_toast.replace('__LIMIT__', limit));
  }

  function showToast(text) {
    var existing = document.querySelector('[data-cart-val-toast]');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.setAttribute('data-cart-val-toast', '');
    t.className = 'c-cart-val-toast';
    // チェックが勝手に外れた理由（保存失敗）をスクリーンリーダーにも伝える
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-show'); }, 10);
    setTimeout(function () {
      t.classList.remove('is-show');
      setTimeout(function () { t.remove(); }, 300);
    }, 2400);
  }

  /* ── Checkout ブロック判定 ─────────────────────────── */
  // ブロックの実体は c_checkout-guard.js が持つ。
  // ここは「混在確認が未同意」「受注品の納期確認が未同意」の 2 つの理由を
  // 登録・解除するだけにして、ギフト包装など他機能のブロックを
  // 踏み潰さないようにする。
  var REASON_MIXED = 'cart-val-mixed';
  var REASON_PREORDER = 'cart-val-preorder';

  function scrollToValidationCard() {
    var root = getValidationRoot();
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function applyBlockState() {
    var guard = window.CCheckoutGuard;
    if (!guard) return;

    var root = getValidationRoot();
    var needShipTogether = false;
    var needPreorderAck = false;

    if (root) {
      if (root.getAttribute('data-mixed') === 'true') {
        var box = root.querySelector('[data-attr="ship_together"]');
        needShipTogether = !box || !box.checked;
      }
      if (root.getAttribute('data-multi-preorder') === 'true') {
        var box2 = root.querySelector('[data-attr="preorder_acknowledged"]');
        needPreorderAck = !box2 || !box2.checked;
      }
    }

    if (needShipTogether) {
      guard.block(REASON_MIXED, scrollToValidationCard);
    } else {
      guard.unblock(REASON_MIXED);
    }

    if (needPreorderAck) {
      guard.block(REASON_PREORDER, scrollToValidationCard);
    } else {
      guard.unblock(REASON_PREORDER);
    }
  }

  function updateAttribute(name, value) {
    var body = new FormData();
    body.append('attributes[' + name + ']', value);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    });
  }

  // ドロワーとカートページの両方に同じチェックがあるので、両方を揃える。
  // 揃えないと、判定に使う側が未チェックのまま残り決済ロックが外れない。
  function setAllChecks(attr, state) {
    document.querySelectorAll('[data-cart-val-check][data-attr="' + attr + '"]').forEach(function (box) {
      box.checked = state;
    });
  }

  // チェック項目ごとの保存状態。
  //   saved   : 最後に保存できた値（＝ cart.attributes と一致している値）
  //   desired : 画面上の最新の値
  //   busy    : 保存リクエストが飛んでいる間 true
  // 保存は項目ごとに 1 本ずつ順に送り、送るのは常に最新の desired にする。
  // 並行して飛ばすと、遅れて返った古いリクエストの結果が新しい操作を上書きし、
  // 画面とサーバーがずれる（同意していないのにロックが外れることがある）。
  var saveStates = {};

  function saveCheck(attr) {
    var s = saveStates[attr];
    var value = s.desired;
    s.busy = true;
    // fetch は 4xx/5xx では reject しないので ok を見る
    updateAttribute(attr, value ? 'yes' : 'no')
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update.js ' + res.status);
        s.saved = value;
        return true;
      })
      .catch(function () {
        return false;
      })
      .then(function (ok) {
        s.busy = false;
        if (!ok) {
          // 失敗したら最後に保存できた値に戻す。戻さないと cart.attributes に同意が
          // 残らないままロックが外れて決済に進めてしまう。待っている操作も捨てる。
          s.desired = s.saved;
          setAllChecks(attr, s.saved);
          showToast(getStrings().save_error);
        } else if (s.desired !== s.saved) {
          // 保存中に操作が変わっていたら、最新の値をもう一度送る
          saveCheck(attr);
          return;
        } else {
          // 保存中にカードが描き直されると、描画時点の古い checked に戻っていることがある。
          // 保存できた値を貼り直してから判定する。
          setAllChecks(attr, s.saved);
        }
        applyBlockState();
      });
  }

  function onCheckboxChange(e) {
    var input = e.target;
    if (!input.matches('[data-cart-val-check]')) return;
    var attr = input.getAttribute('data-attr');
    if (!attr) return;
    if (!saveStates[attr]) {
      // 初回は「操作の直前の状態」がサーバーに保存済みの値（描画時の checked）
      saveStates[attr] = { saved: !input.checked, desired: input.checked, busy: false };
    }
    var s = saveStates[attr];
    s.desired = input.checked;
    setAllChecks(attr, input.checked);
    // 外したときはその場でロックする（ロックする方向は常に安全）。
    // 入れたときのロック解除だけは、保存が済むまで待つ。
    if (!input.checked) applyBlockState();
    if (!s.busy) saveCheck(attr);
  }

  function init() {
    applyCartLimits();
    // 確認カードが無いカート（混在も受注品複数も無い）でも、
    // 前回の描画で残った理由を必ず解除するため applyBlockState は常に呼ぶ。
    document.addEventListener('change', onCheckboxChange);
    applyBlockState();
    document.addEventListener('input', clampOnInput);
    document.addEventListener('submit', enforcePdpQuantity, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // cart-drawer などが Ajax で再描画したタイミングで再評価
  document.addEventListener('cart:refresh', function () {
    applyCartLimits();
    // 保存中に描き直されたカードは、保存前の checked で描かれている。
    // お客様の最新の操作を貼り直す（保存中でない項目はサーバーの値を正とする）。
    Object.keys(saveStates).forEach(function (a) {
      if (saveStates[a].busy) setAllChecks(a, saveStates[a].desired);
    });
    applyBlockState();
  });
})();
